import { CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { readFromBinaryFile } from 'exif-js';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { env } from '../../../environments/environment';
import { DialogService } from '../../dialog/dialog.service';
import { FlagGroupService } from '../../flag/flag.group.service';
import { FlagService } from '../../flag/flag.service';
import { SettingService } from '../../setting/setting.service';
import { dateAsString, dateTimeAsString } from '../../shared/date.helper';
import { GoogleService } from '../../shared/google.service';
import {
  Flag,
  FlagGroup,
  FlagGroupTag,
  FlagStatus,
  FlagSubtype,
  Inspection,
  InspectionItem,
  ItemInfo,
  Setting,
  UnderwritingStatus,
} from '../../shared/interfaces';
import { VersionService } from '../../version/version.service';
import { AnswerPicturesComponent } from '../answer-pictures/answer-pictures.component';
import { AnswerStatus } from '../answer.status';
import { GroupPickerComponent } from '../group-picker/group-picker.component';
import { InspectionCommentComponent } from '../inspection-comment/inspection-comment.component';
import { InspectionService } from '../inspection.service';
import { InspectionStatus, statusAsText } from '../inspection.status';
import {
  InspectionFilters,
  ReviewNavigationAction,
  ReviewNavigationComponent,
} from '../review.navigation/review.navigation.component';
import { InspectionSetDeadlinesComponent } from '../set.violation.deadlines/set.violation.deadlines.component';
import { FlagGroupTemplateComponent } from '../flag-group-template/flag-group-template.component';
import { ExtensionGrantedDeadlinesComponent } from '../extension-granted-deadlines/extension-granted-deadlines.component';

@Component({
  selector: 'app-flag-manager',
  templateUrl: './flag-manager.component.html',
  styleUrls: ['./flag-manager.component.scss'],
})
export class FlagManagerComponent implements OnInit, OnChanges {
  constructor(
    private flagService: FlagService,
    private groupService: FlagGroupService,
    private inspectionService: InspectionService,
    private versionService: VersionService,
    private toastr: ToastrService,
    private dialog: DialogService,
    public settingService: SettingService,
    public googleService: GoogleService,
    public route: ActivatedRoute,
    private router: Router,
    private flagGroupService: FlagGroupService,
  ) {}

  get selectedGroup() {
    return this._selectedGroup;
  }
  set selectedGroup(x) {
    if (this._selectedGroup !== x) {
      this.uncheckAllFlags();
      this._selectedGroup = x;
      this.setCurrentFlags();
      if (this.flagListStep1.first) {
        this.flagListStep1.first.nativeElement.scrollTop = 0;
      }
      if (this.flagListStep3.first) {
        this.flagListStep3.first.nativeElement.scrollTop = 0;
      }
      this.editingFlag = null;
      this.editingGroup = null;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { groupId: this.selectedGroup ? x.id : null, flagId: null },
        queryParamsHandling: 'merge',
      });
    }
  }

  get selectedGroups() {
    return this.groups.filter(g => g.checkbox.value);
  }

  get selectedFlags() {
    return this.currentFlags.filter(f => f.checkbox.value);
  }

  get ignored() {
    return this.currentFlags.filter(f => f.ignore);
  }
  get kept() {
    return this.currentFlags.filter(f => !f.ignore);
  }
  get unResolved() {
    return this.currentFlags.filter(f => f.status === FlagStatus.UNRESOLVED);
  }
  get partialResponse() {
    return this.currentFlags.filter(f => f.status === FlagStatus.PARTIAL_RESPONSE);
  }
  get resolved() {
    return this.currentFlags.filter(f => f.status === FlagStatus.RESOLVED);
  }
  get underwritingStatus() {
    return this._underwritingStatus;
  }
  set underwritingStatus(x) {
    this._underwritingStatus = x;
    this.updateUnderwritingStatus();
  }

  get activeStep() {
    return this._activeStep;
  }
  set activeStep(x) {
    this._activeStep = x;
    setTimeout(() => this.handleScroll(), 0);
  }

  get editingGroupChanges() {
    if (this.editingGroup && this.currentFlags.length > 0) {
      let changeLog = this.currentFlags[0].changes;

      changeLog = changeLog.filter(
        (item, index, self) =>
          index === self.findIndex(obj => JSON.stringify(obj.changes) === JSON.stringify(item.changes)),
      );

      return changeLog;
    }
    return [];
  }

  get totalResolved() {
    return this.allFlags.filter(f => f.status === FlagStatus.RESOLVED).length;
  }
  get totalPartiallyResponse() {
    return this.allFlags.filter(f => f.status === FlagStatus.PARTIAL_RESPONSE).length;
  }
  get totalUnResolve() {
    return this.allFlags.filter(f => f.status === FlagStatus.UNRESOLVED).length;
  }

  OverrideOption = OverrideOption;
  UnlinkAllOption = UnlinkAllOption;
  LastFlagOption = LastFlagOption;
  FlagStatus = FlagStatus;
  subtypeInfo: Setting[];
  showComments = false;
  allCommentsLength;
  _selectedGroup: FlagGroup;
  changeStatus = false;
  loading = false;
  flagChangelog = false;
  @Input() inspection: Inspection;
  @Input() filters: InspectionFilters;
  @Input() navigation: ReviewNavigationComponent;
  @Input() existingLetters: any[];

  @Output() refreshAnswers = new EventEmitter<void>();
  @ViewChild(InspectionCommentComponent) inspectionCommentComponent: InspectionCommentComponent;

  underwritingStatusMapping = {
    '1': 'Prepare flags for rec letter',
    '2': 'Flags preparation in progress',
    '3': 'Rec letter sent to customer',
    '4': 'Resolution in progress',
    '5': 'Closed',
  };

  selectedPicture: any;
  selectedFlag: any;
  exif;

  dateAsString = dateAsString;
  dateTimeAsString = dateTimeAsString;
  statusAsText = statusAsText;
  InspectionStatus = InspectionStatus;
  UnderwritingStatus = UnderwritingStatus;

  enabledStatesStep3 = [
    UnderwritingStatus.CLOSED,
    UnderwritingStatus.LETTER_SENT,
    UnderwritingStatus.RESOLUTION_IN_PROGRESS,
  ];

  _underwritingStatus: UnderwritingStatus;

  public AnswerStatus = AnswerStatus;

  @Input() answers;

  @ViewChildren('answerPictures') answerPictures: QueryList<AnswerPicturesComponent>;
  @ViewChildren('questionDiv') questionDiv: QueryList<ElementRef>;
  @ViewChildren('flagListStep1') flagListStep1: QueryList<ElementRef>;
  @ViewChildren('flagListStep3') flagListStep3: QueryList<ElementRef>;
  @ViewChild('wrapper', { static: true }) private wrapper: ElementRef;
  @ViewChild('groupPicker', { static: true }) private groupPicker: GroupPickerComponent;
  @ViewChild('overrideOptions', { static: true }) public overrideOptions: ModalDirective;
  @ViewChild('unlinkAllOptions', { static: true }) public unlinkAllOptions: ModalDirective;
  @ViewChild('lastFlagOptions', { static: true }) public lastFlagOptions: ModalDirective;
  @ViewChild('setDeadlinesModal', { static: true }) public setDeadlinesModal: ExtensionGrantedDeadlinesComponent;
  @ViewChild('ExtensionGrantedDeadlinesModal', { static: true })
  public ExtensionGrantedDeadlinesModal: InspectionSetDeadlinesComponent;
  @ViewChild('flagGroupTemplateModal', { static: true }) public flagGroupTemplateModal: FlagGroupTemplateComponent;
  @ViewChild('flagListStep3') flagListStep33: ElementRef;

  groups: any[];
  editingGroup;
  editingFlag;
  allFlags: any[];
  items: any[];
  totalFlags: number;
  scoresEnabled = false;
  managingGroups = false;

  currentFlags = [];
  countUncategorized = 0;

  generatingDoc = false;

  allQuestions = [];
  expandedIds: string[] = [];

  overrideOptionResolver: (value: OverrideOption | PromiseLike<OverrideOption>) => void;
  unlinkAllOptionResolver: (value: UnlinkAllOption | PromiseLike<UnlinkAllOption>) => void;
  lastFlagOptionResolver: (value: LastFlagOption | PromiseLike<LastFlagOption>) => void;

  accordion = {
    active: 'details',
    toggle: function (name) {
      this.active = this.active === name ? null : name;
    },
  };

  _activeStep: 1 | 2 | 3 = 1;

  stickySize = 0;
  stickyTitle = 'To be Resolved';
  flagGroupTags: FlagGroupTag[] = [];

  async ngOnInit() {
    this.scoresEnabled = await this.settingService.scoresEnabled();

    this.flagGroupTags = await this.flagGroupService.tags();
    for (const group of this.flagGroupTags) {
      if (group.subgroups && group.subgroups.length > 0) {
        for (const subgroup of group.subgroups) {
          const templates = await this.flagGroupService.templates(subgroup.id);
          subgroup.templates = templates;
        }
      }
    }
  }

  ngDoCheck() {
    if (this.navigation.isRecLetterSend.value) {
      this.underwritingStatus = 3;
      this.activeStep = 3;
      this.navigation.isRecLetterSend = { value: false };
    }

    const timestamp = Date.now();

    this.currentFlags?.forEach(flag => {
      const pictureId = flag?.picture?.id;
      if (!pictureId) return;

      if (!flag.imageUrl || flag._needsImageRefresh) {
        flag.imageUrl = `${env.APIUrl}/image/embedded/${pictureId}?t=${timestamp}`;
        flag._needsImageRefresh = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('answers' in changes) {
      if (this.answers) {
        this.load();
      }
    }
    if ('filters' in changes) {
      this.setCurrentFlags();
    }
    if ('inspection' in changes) {
      this._underwritingStatus = this.inspection && this.inspection.underwritingStatus;

      if (this.enabledStatesStep3.includes(+this.underwritingStatus)) {
        this.activeStep = 3;
      }
    }
  }

  async loadItems() {
    this.items = [];

    const items = (await this.versionService.tree(this.inspection.versionId)).items;

    // filter empty sections
    items.forEach(item => {
      item.sections = item.sections.filter(section => section.questions.length);
    });

    // filter empty items
    items.forEach((item: any, i) => {
      if (!item.sections.length) {
        delete items[i];
      } else {
        item.info = this.inspection.items.find(info => info.itemId === item.id);
      }
    });

    items.forEach((item: InspectionItem & { info: ItemInfo }) => {
      if (!item.info) {
        return;
      }

      if (item.info.quantity === 1) {
        const customName = item.info.names && item.info.names[0];
        const defaultName = item.name;
        const label = customName ? `${customName} (${defaultName})` : defaultName;

        this.items.push({
          ...item,
          label,
        });
      } else if (item.info.quantity > 1) {
        for (let i = 0; i < item.info.quantity; i++) {
          const customName = item.info.names && item.info.names[i];
          const defaultName = item.name;
          const label = customName ? `${customName} (${defaultName})` : defaultName;

          this.items.push({
            // deep copy
            ...JSON.parse(JSON.stringify(item)),
            label,
            index: i + 1,
          });
        }
      }
    });
  }

  // for setting the color of select by css class
  getClassByUnderwritingStatus(): string {
    const underwritingStatusClass: { [key: string]: string } = {
      '1': 'select-primarys', // Assuming 'select-primarys' is intentional and not a typo for 'select-primary'.
      '2': 'select-success',
      '3': 'select-warning',
      '4': 'select-danger',
      '5': 'select-primarys',
    };

    // Default class if underwritingStatus is not found
    const defaultClass = 'default-class'; // Replace 'default-class' with your actual default class

    return underwritingStatusClass[this.underwritingStatus] || defaultClass;
  }

  // tslint:disable: forin
  async mergeAnswers() {
    for (const iItem in this.items) {
      const item = this.items[iItem];
      const sections = item.sections;
      const buildingIndex = item.index;

      for (const iSection in sections) {
        const section = sections[iSection];
        const questions = section.questions;

        for (const iQuestion in questions) {
          const question = questions[iQuestion];

          if (question.repeat && question.repeat.length) {
            question.repeat.forEach(itemId => {
              question.answer = this.answers.filter(ans => {
                return ans.questionId === question.id;
              });
            });
          } else {
            const answer = this.answers.find(ans => {
              const indexOk = !buildingIndex || ans.buildingIndex === buildingIndex;
              return ans.questionId === question.id && indexOk;
            });

            if (answer) {
              question.answer = answer;
            }
          }

          const answers = Array.isArray(question.answer) ? question.answer : [question.answer];

          answers.forEach(answer => {
            if (answer) {
              answer.question = question;

              // set images' path for tooltip
              answer.pictures.forEach(pic => {
                pic.path = `${item.label} / ${section.name} / ${question.text}`;
              });

              // set flags & comments' deeplink
              [...answer.flags, ...answer.comments].forEach((x: any) => {
                x.deeplink = [+iItem, +iSection, +iQuestion];
              });
            }
          });
        }
      }
    }
  }
  getComments(q) {
    if (q?.answer) {
      if (Array.isArray(q.answer)) {
        return q.answer.reduce((acc, cur) => [...acc, ...cur.comments], []);
      } else {
        return q.answer.comments;
      }
    }
    return [];
  }

  // tslint:disable:forin
  loadComments() {
    this.allQuestions = [];

    for (const iItem in this.items) {
      const item = this.items[iItem];
      const sections = item.sections;

      for (const iSection in sections) {
        const section = sections[iSection];
        const questions = section.questions;

        const sectionComments = [];

        for (const iQuestion in questions) {
          const question = questions[iQuestion];
          const comments = this.getComments(question);

          sectionComments.push(
            ...comments.map(f => ({
              ...f,
              questionId: question.id,
              question: question.text,
            })),
          );
        }

        if (sectionComments.length) {
          this.allQuestions.push(...sectionComments);
        }
      }
    }
  }

  getQuestionComments(questionId) {
    return this.allQuestions.filter(q => q.questionId === questionId);
  }

  getQuestionCommentsTotal(questionId) {
    return this.getQuestionComments(questionId).length;
  }

  subtypeName(subtype: FlagSubtype) {
    const info = this.flagService.getSubtypeInfo(this.subtypeInfo, subtype.name);
    return info?.name;
  }

  async load() {
    if (!this.inspection) return;

    this.subtypeInfo = await this.flagService.subtypeInfo;
    await this.reloadAnswers();
    await this.loadGroups();
    await this.loadItems();
    await this.mergeAnswers();
    await this.loadComments();
    this.getAllFlags();
    this.checkUnderwritingStatus();

    const params = this.route.snapshot.queryParams;
    if (params.groupId) {
      const group = this.groups.find(g => g.id === Number(params.groupId));
      this.openGroup(group);
    } else if (params.flagId) {
      this.editingFlag = this.allFlags.find(f => f.id === Number(params.flagId));
    }
  }

  async reloadAnswers() {
    this.answers = await this.inspectionService.answers(this.inspection.id);
  }

  async loadGroups() {
    this.groups = (await this.groupService.listByInspection(this.inspection.id))[0];
    this.groups.sort((a, b) => a.order - b.order);

    this.groups.forEach(group => {
      group.checkbox = new UntypedFormControl(false);
    });
  }

  getAllFlags() {
    this.allFlags = [];

    for (const iItem in this.items) {
      const item = this.items[iItem];
      const sections = item.sections;
      const buildingIndex = item.index;

      for (const iSection in sections) {
        const section = sections[iSection];
        const questions = section.questions;

        const sectionFlags = [];

        for (const iQuestion in questions) {
          const question = questions[iQuestion];
          const flags = this.getFlags(question);

          sectionFlags.push(
            ...flags.map(f => ({
              ...f,
              flag: f,
              questionId: question.id,
              question: `${question.legacyId ? question.legacyId + '.' : ''} ${question.text}`,
              label: `${item.label} ${buildingIndex ? '#' + buildingIndex : ''} / ${section.name}`,
              hasPictures: this.nPictures(question),
            })),
          );
        }

        if (sectionFlags.length) {
          this.allFlags.push(...sectionFlags);
        }
      }
    }

    this.allFlags.forEach(flag => {
      flag.checkbox = new UntypedFormControl(false);
    });

    this.setCurrentFlags();
  }

  setCurrentFlags() {
    if (!this.allFlags) {
      return;
    }

    const group = this.selectedGroup;
    let filteredFlags = this.allFlags.filter(f =>
      this.filters && this.filters.questions === 'autoScored' ? !f.userId : true,
    );

    if (this.filters && this.filters.flags && this.filters.flags !== 'all') {
      filteredFlags = this.allFlags.filter(
        f => this.filters && this.filters.flags !== 'all' && this.filters.flags.includes(f.subtypeId),
      );
    }

    // tslint:disable-next-line:triple-equals
    this.currentFlags = filteredFlags.filter(f => f.groupId == group?.id);

    this.groups.forEach(g => (g.count = filteredFlags.filter(f => f.groupId === g.id).length));
    this.countUncategorized = filteredFlags.filter(f => !f.groupId).length;

    this.handleScroll();
  }

  nPictures(q) {
    if (q?.answer) {
      if (Array.isArray(q.answer)) {
        return q.answer.reduce((acc, cur) => acc + cur.pictures.filter(p => !p.related).length, 0);
      } else {
        return q.answer.pictures.filter(p => !p.related).length;
      }
    }
    return 0;
  }

  getFlags(q) {
    // Ignoring related
    if (q?.answer) {
      if (Array.isArray(q.answer)) {
        return q.answer.reduce((acc, ans) => [...acc, ...ans.flags.filter(f => f.answerId === ans.id)], []);
      } else {
        return q.answer.flags.filter(f => f.answerId === q.answer.id);
      }
    }
    return [];
  }

  getFlagHighlightClass(flag) {
    const score = this.scoresEnabled ? flag.score : 0;

    if (this.activeStep === 1) {
      return {
        red: score >= 100,
        orange: score >= 5 && score < 100,
        amber: score >= 1 && score < 5,
        selected: flag === this.editingFlag,
        excluded: flag.ignore,
        completed: this.isFilled(flag),
      };
    }

    if (this.activeStep === 3) {
      return {};
    }
  }

  async groupSaved(newGroup) {
    this.toastr.success(newGroup.new ? 'Group created!' : 'Group saved!');

    const group = this.groups.find(g => g.id === newGroup.id);
    if (group) {
      Object.assign(group, newGroup);

      this.allFlags
        .filter(f => f.groupId === group.id)
        .forEach(f => {
          Object.assign(f.violation, group.violation);
          Object.assign(f.discrepancy, group.discrepancy);
          f.description = group.description;
          f.subtype = group.subtype;
          f.subtypeId = group.subtypeId;
        });
    } else {
      newGroup.checkbox = new UntypedFormControl(false);
      newGroup.count = 0;
    }
    this.editingGroup = null;
    this.editingFlag = null;
    await this.load();

    this.checkUnderwritingStatus();
  }

  addGroup() {
    this.editingGroup = {};
    this.uncheckAllFlags();
  }

  openGroup(group) {
    this.selectedGroup = group;
  }

  removeGroup(group) {
    this.dialog.confirm().show({
      message: `Do you want to permanently delete this group?`,
      confirmed: async () => {
        await this.groupService.remove(group.id);
        this.toastr.success('Group removed');
        this.groups = this.groups.filter(g => g.id !== group.id);
        this.selectedGroup = null;

        this.allFlags.forEach(f => {
          if (f.groupId === group.id) {
            f.group = null;
            f.groupId = null;
          }
        });

        this.setCurrentFlags();
      },
    });
  }

  async removeSelected() {
    this.dialog.confirm().show({
      message: `Do you want to permanently delete these groups?`,
      confirmed: async () => {
        const promises = [];
        const ids = this.selectedGroups.map(g => g.id);

        ids.forEach(id => promises.push(this.groupService.remove(id)));
        await Promise.all(promises);

        this.toastr.success('Groups removed');
        this.groups = this.groups.filter(g => !ids.includes(g.id));
        this.selectedGroup = null;

        this.allFlags.forEach(f => {
          if (ids.includes(f.groupId)) {
            f.group = null;
            f.groupId = null;
          }
        });

        this.setCurrentFlags();
      },
    });
  }

  editGroup(group, flag = null, accordion = 'details') {
    if (group && accordion == 'changelog') {
      this.flagChangelog = true;
    } else {
      this.flagChangelog = false;
    }

    setTimeout(() => {
      this.accordion.active = accordion;
      this.editingGroup = group;
      this.uncheckAllFlags();
      this.editingFlag = flag;
      // Uncategorized
      if (!group) {
        this.editingFlag = flag;
      }
    }, 0);
  }

  embeddedUrl(picture) {
    return `${env.APIUrl}/image/embedded/${picture.id}`;
  }

  confirmOverridingInfo() {
    return new Promise<boolean>(res => {
      this.dialog.confirm().show({
        message: `The flag-level information will be deleted and replace by the group-level information, do you want to continue?.`,
        confirmed: () => res(true),
        canceled: () => res(false),
      });
    });
  }

  askUnlinkAllOption() {
    this.unlinkAllOptions.show();
    return new Promise<UnlinkAllOption>(res => (this.unlinkAllOptionResolver = res));
  }

  askLastFlagOption() {
    this.lastFlagOptions.show();
    return new Promise<LastFlagOption>(res => (this.lastFlagOptionResolver = res));
  }

  askOverridingOption() {
    this.overrideOptions.show();
    return new Promise<OverrideOption>(res => (this.overrideOptionResolver = res));
  }

  async flagDropped(ev, group) {
    if (ev.isPointerOverContainer) {
      this.editingFlag = null;
      const flag = ev.item.data;

      if (this.hasInfoDefined(group)) {
        if (!(await this.confirmOverridingInfo())) {
          return false;
        }
      }

      if (group && this.hasInfoDefined(flag)) {
        if (!this.hasInfoDefined(group)) {
          const option = await this.askOverridingOption();
          this.overrideOptions.hide();

          if (option === OverrideOption.CANCEL) {
            return;
          }

          if (option === OverrideOption.USE_FLAG_INFO) {
            Object.assign(group.violation, flag.violation);
            Object.assign(group.discrepancy, flag.discrepancy);
            group.subtype = flag.subtype;
            group.subtypeId = flag.subtypeId;
            group.description = flag.description;
            await this.groupService.edit(group.id, group);
            this.toastr.success('Group saved!');
          }
        }
      }

      if (group && !group.subtypeId) {
        group.subtype = flag.subtype;
        group.subtypeId = flag.subtypeId;
      }

      flag.groupId = group?.id;
      flag.group = group;

      // update "global" object
      flag.flag.groupId = group?.id;
      flag.flag.group = group;

      if (group) {
        Object.assign(flag.violation, group.violation);
        Object.assign(flag.discrepancy, group.discrepancy);
        flag.subtype = group.subtype;
        flag.subtypeId = group.subtypeId;
        flag.description = group.description;

        // update "global" object
        Object.assign(flag.flag.violation, group.violation);
        Object.assign(flag.flag.discrepancy, group.discrepancy);
        flag.flag.subtype = group.subtype;
        flag.flag.subtypeId = group.subtypeId;
        flag.flag.description = group.description;
      }

      this.setCurrentFlags();

      await this.flagService.addToGroup(group?.id, flag.id).then(x => {
        // fetch async changelog
        setTimeout(async () => {
          const updatedFlag = await this.flagService.get(flag.id);
          flag.changes = updatedFlag.changes;
        }, 500);
      });
      this.toastr.success('Flag saved!');

      if (this.currentFlags.length === 0) {
        const option = await this.askLastFlagOption();

        this.lastFlagOptions.hide();

        if (option === LastFlagOption.CLEAR) {
          const group = this.selectedGroup;
          group.violation = {} as any;
          group.discrepancy = {} as any;
          group.description = null;

          await this.groupService.edit(group.id, group);
          this.toastr.success('Group saved');
          this.editingGroup = null;
        }
      }
    }
  }

  noReturnPredicate() {
    return false;
  }

  notSameGroupPredicate(drag, list) {
    const flag = drag.data;
    const group = list.data;
    return flag.groupId !== (group ? group.id : null);
  }

  sameTypePredicate(flagCard: CdkDrag, groupList: CdkDropList) {
    const group = groupList.data;
    const newFlag = flagCard.data;
    return (
      newFlag.groupId !== (group ? group.id : null) &&
      (!group.subtypeId || newFlag.subtype.typeId === group.subtype.typeId)
    );
  }

  hasInfoDefined(flagOrGroup) {
    const values = [
      flagOrGroup.description,
      ...Object.values(flagOrGroup.violation),
      ...Object.values(flagOrGroup.discrepancy),
    ];
    return !!values.find(x => !!x);
  }

  async ignore(flag) {
    flag.ignore = true;
    // update original/shared object
    flag.flag.ignore = true;
    await this.flagService.edit(flag.id, flag);
    this.toastr.success('The flag will be excluded from the report but it can be added back in any time');

    // fetch async changelog
    setTimeout(async () => {
      const updatedFlag = await this.flagService.get(flag.id);
      flag.changes = updatedFlag.changes;
    }, 500);
  }

  async restore(flag) {
    flag.ignore = false;
    // update original/shared object
    flag.flag.ignore = false;
    await this.flagService.edit(flag.id, flag);
    this.toastr.success('Flag saved');

    // fetch async changelog
    setTimeout(async () => {
      const updatedFlag = await this.flagService.get(flag.id);
      flag.changes = updatedFlag.changes;
    }, 500);
  }

  isCompleted(flagOrGroup: Flag | FlagGroup) {
    // Uncategorized
    if (!flagOrGroup) {
      return this.allFlags && !this.allFlags.filter(f => !f.groupId).find(f => !this.isCompleted(f));
    }

    return this.flagService.isCompleted(flagOrGroup);
  }

  isFilled(flagOrGroup: Flag | FlagGroup) {
    // Uncategorized
    if (!flagOrGroup) {
      return this.allFlags && !this.allFlags.filter(f => !f.groupId).find(f => !this.isFilled(f));
    }

    return this.flagService.isFilled(flagOrGroup);
  }

  nCompletedFlags() {
    if (this.allFlags) {
      return this.allFlags.reduce((total, flag) => (this.isCompleted(flag) ? total + 1 : total), 0);
    }
  }

  canMerge() {
    if (this.selectedGroups.length < 2) {
      return;
    }

    const type = this.selectedGroups[0].typeId;
    return !this.selectedGroups.find(g => g.typeId && g.typeId !== type);
  }

  async mergeGroups() {
    const targetGroup = await this.groupPicker.ask(this.selectedGroups);

    if (!targetGroup) {
      return;
    }

    const groupIds = this.selectedGroups.filter(g => g.id !== targetGroup.id).map(g => g.id);
    const flags = this.allFlags.filter(f => groupIds.includes(f.groupId));

    flags.forEach(flag => {
      flag.groupId = targetGroup.id;
      flag.group = targetGroup;
      Object.assign(flag.violation, targetGroup.violation);
      Object.assign(flag.discrepancy, targetGroup.discrepancy);
      flag.subtype = targetGroup.subtype;
      flag.subtypeId = targetGroup.subtypeId;
      flag.description = targetGroup.description;

      // update "global" object
      flag.flag.groupId = targetGroup.id;
      flag.flag.group = targetGroup;
      Object.assign(flag.flag.violation, targetGroup.violation);
      Object.assign(flag.flag.discrepancy, targetGroup.discrepancy);
      flag.flag.subtype = targetGroup.subtype;
      flag.flag.subtypeId = targetGroup.subtypeId;
      flag.flag.description = targetGroup.description;
    });

    await Promise.all(
      flags.map(f =>
        this.flagService.addToGroup(targetGroup.id, f.id).then(x => {
          // fetch async changelog
          setTimeout(async () => {
            const updatedFlag = await this.flagService.get(f.id);
            f.changes = updatedFlag.changes;
          }, 500);
        }),
      ),
    );

    const idsToRemove = this.selectedGroups.filter(g => g.id !== targetGroup.id).map(g => g.id);
    this.groups = this.groups.filter(g => !idsToRemove.includes(g.id));
    this.selectedGroup = targetGroup;

    await Promise.all(idsToRemove.map(id => this.groupService.remove(id)));

    this.toastr.success('Groups merged');
    this.setCurrentFlags();
  }

  uncheckAllFlags() {
    this.allFlags.forEach(f => f.checkbox.setValue(false));
    this.changeStatus = false;
  }

  canGroupFlags() {
    if (this.selectedFlags.length < 2) {
      return;
    }

    if (!this.selectedFlags[0]?.subtype && !this.selectedFlags[0]?.subtype?.typeId) {
      return;
    }

    const type = this.selectedFlags[0]?.subtype?.typeId;

    // Incompatible flags
    if (this.selectedFlags.find(f => f.subtype.typeId !== type)) {
      return false;
    }

    // Incompatible groups
    if (!this.groups.find(g => !g.subtype || g.subtype.typeId === type)) {
      return false;
    }

    return true;
  }

  async groupFlags() {
    const type = this.selectedFlags[0].subtype.typeId;
    const groups = this.groups.filter(g => !g.subtype || g.subtype.typeId === type);

    let targetGroup = await this.groupPicker.ask(groups);
    if (!targetGroup) {
      return;
    }
    //get Updated Groups
    if (!targetGroup.subtype) {
      await this.loadGroups();
      targetGroup = this.groups.find(group => group.id == targetGroup.id);
    }
    await Promise.all(
      this.selectedFlags.map(f => {
        f.group = targetGroup;
        f.groupId = targetGroup.id;
        Object.assign(f.violation, targetGroup.violation);
        Object.assign(f.discrepancy, targetGroup.discrepancy);
        f.subtype = targetGroup.subtype;
        f.subtypeId = targetGroup.subtypeId;
        f.description = targetGroup.description;

        return this.flagService.addToGroup(targetGroup.id, f.id).then(x => {
          // fetch async changelog
          setTimeout(async () => {
            const updatedFlag = await this.flagService.get(f.id);
            f.changes = updatedFlag.changes;
          }, 500);
        });
      }),
    );
    this.load();
    this.toastr.success('Flags saved');
    this.setCurrentFlags();
  }

  ungroupFlags() {
    const nSelected = this.selectedFlags.length;
    const nTotalFlags = this.currentFlags.length;

    if (nSelected === nTotalFlags) {
      return this.unlinkAllFromSelectedGroup();
    }

    this.dialog.confirm().show({
      message: `Do you want to unlink all selected flags?`,
      confirmed: async () => {
        await Promise.all(
          this.selectedFlags.map(f => {
            f.group = null;
            f.groupId = null;
            return this.flagService.addToGroup(null, f.id).then(x => {
              // fetch async changelog
              setTimeout(async () => {
                const updatedFlag = await this.flagService.get(f.id);
                f.changes = updatedFlag.changes;
              }, 500);
            });
          }),
        );

        this.toastr.success('Flags saved');
        this.setCurrentFlags();
      },
    });
  }

  async ignoreFlags() {
    this.dialog.confirm().show({
      message: `Do you want to ignore all selected flags?`,
      confirmed: async () => {
        await Promise.all(
          this.selectedFlags.map(flag => {
            flag.ignore = true;
            // update original/shared object
            flag.flag.ignore = true;
            flag.checkbox.setValue(false);
            return this.flagService.edit(flag.id, flag).then(x => {
              // fetch async changelog
              setTimeout(async () => {
                const updatedFlag = await this.flagService.get(flag.id);
                flag.changes = updatedFlag.changes;
              }, 500);
            });
          }),
        );
        this.toastr.success('Flags saved');
      },
    });
  }

  async keepFlags() {
    this.dialog.confirm().show({
      message: `Do you want to keep all selected flags?`,
      confirmed: async () => {
        await Promise.all(
          this.selectedFlags.map(flag => {
            flag.ignore = false;
            // update original/shared object
            flag.flag.ignore = false;
            flag.checkbox.setValue(false);
            return this.flagService.edit(flag.id, flag).then(x => {
              // fetch async changelog
              setTimeout(async () => {
                const updatedFlag = await this.flagService.get(flag.id);
                flag.changes = updatedFlag.changes;
              }, 500);
            });
          }),
        );
        this.toastr.success('Flags saved');
      },
    });
  }

  dateFromExif() {
    if (!this.exif || !this.exif.length) {
      return 'No EXIF data';
    }

    const dateTimeEntry = this.exif.find(e => e.key.startsWith('Date'));
    const dateTime = dateTimeEntry?.value;

    if (!dateTime) {
      return 'No EXIF data';
    }

    return `${dateTime.slice(5, 7)}/${dateTime.slice(8, 10)}/${dateTime.slice(0, 4)} ${dateTime.slice(11)}`;
  }

  async loadExif(blob) {
    try {
      const exif = readFromBinaryFile(await blob.arrayBuffer());

      const blackList = ['makernote', 'preview', 'thumb', 'error'];
      this.exif = Object.keys(exif)
        .filter(key => {
          for (const b of blackList) {
            if (key.toLowerCase().indexOf(b) >= 0) {
              return false;
            }
          }
          return true;
        })
        .reduce((acc, curr) => [...acc, { key: curr, value: exif[curr] }], []);
    } catch (e) {
      console.log('Error getting EXIF');
    }
  }

  openPicture(flag) {
    this.selectedPicture = flag.picture;
    this.selectedFlag = flag;
  }

  updateFlag(newFlag) {
    this.toastr.success('Flag Saved');

    // update fields
    Object.assign(this.editingFlag, newFlag);
    Object.assign(this.editingFlag.flag, newFlag);

    this.editingFlag = null;
    this.checkUnderwritingStatus();
  }

  async moveFlag({ flag, x, y }) {
    this.selectedFlag.x = x;
    this.selectedFlag.y = y;

    await this.flagService.edit(flag.id, { ...flag, x, y });
    this.toastr.success('Flag Saved');

    this.updateThumb(flag.picture);
  }

  async generateDoc() {
    this.openRecLetterPanel();
  }

  async unlinkAllFromSelectedGroup() {
    const option = await this.askUnlinkAllOption();
    this.unlinkAllOptions.hide();

    if (option === UnlinkAllOption.CANCEL) {
      return;
    }

    if (option === UnlinkAllOption.CLEAR) {
      const group = this.selectedGroup;
      group.violation = {} as any;
      group.discrepancy = {} as any;
      group.description = null;

      await this.groupService.edit(group.id, group);
      this.toastr.success('Group saved');
    }

    await Promise.all(
      this.currentFlags.map(f => {
        f.group = null;
        f.groupId = null;
        return this.flagService.addToGroup(null, f.id).then(x => {
          // fetch async changelog
          setTimeout(async () => {
            const updatedFlag = await this.flagService.get(f.id);
            f.changes = updatedFlag.changes;
          }, 500);
        });
      }),
    );

    const removedFlags = this.currentFlags.map(f => f.id);
    const groups = [];
    for (const group of this.groups) {
      if (group.flags.length) {
        group.flags = group.flags.filter(f => !removedFlags.includes(f.id));
      }
      group.count = group.flags.length;
      groups.push(group);
    }
    this.groups = groups;

    this.toastr.success('Flags saved');
    this.setCurrentFlags();
    this.load();
  }

  selectAll() {
    if (this.selectedFlags.length && this.currentFlags.length === this.selectedFlags.length) {
      // All are selected, so deselect all
      this.selectedFlags.forEach(f => f.checkbox.setValue(false));
      this.changeStatus = false;
      return;
    }

    // Select all
    this.currentFlags.forEach(f => f.checkbox.setValue(true));
  }

  allSelectedAreExcluded() {
    return !this.selectedFlags.find(f => !f.ignore);
  }

  updateThumb(picture) {
    // find and refresh thumb
    const imgs = Array.from(document.getElementsByClassName('thumb-markup')) as HTMLImageElement[];
    imgs.filter(i => i.src.includes(picture.id)).forEach(i => (i.src += '1'));
  }

  getLinkParams(flag) {
    if (flag) {
      const [item, section, question] = flag.deeplink;
      return {
        item,
        section,
        question,
        right: 'question',
        currentImage: undefined,
      };
    }
  }

  async updateUnderwritingStatus() {
    if (this.inspection) {
      await this.inspectionService.setUnderwritingStatus(this.inspection.id, (this.underwritingStatus || -1) as any);
      this.toastr.success('Underwriting status updated!');
      this.inspection.underwritingStatus = +this.underwritingStatus;
      if (this.enabledStatesStep3.includes(+this.underwritingStatus)) {
        this.activeStep = 3;
      } else {
        this.activeStep = 1;
      }
    }
  }

  checkUnderwritingStatus() {
    const flagsAndGroups = [...this.allFlags, ...this.groups];
    const preparationHasStarted = !!flagsAndGroups.find(x => this.hasInfoDefined(x));

    if (preparationHasStarted && this.inspection.underwritingStatus === UnderwritingStatus.PREPARE_FLAGS) {
      this.underwritingStatus = UnderwritingStatus.PREPARATION_IN_PROGRESS;
    }
  }

  stepEnabled(step) {
    switch (step) {
      case 1:
        return true;

      case 2:
        return false;

      case 3:
        if (this.inspection && this.enabledStatesStep3.includes(this.inspection.underwritingStatus)) {
          return true;
        }

        return false;
    }
  }

  async changeFlagStatus(flag, status: FlagStatus) {
    flag.status = status;
    flag.flag.status = status;
    const savedAnswer = await this.flagService.edit(flag.id, flag);
    const savedFlag = savedAnswer.flags?.find(f => f.id === flag.id);
    Object.assign(flag, savedFlag);
    Object.assign(flag.flag, savedFlag);
    this.toastr.success('Flag saved');
  }

  dateIsPast(date) {
    return new Date(date) < new Date();
  }

  async addComment(text) {
    if (text) {
      const saved = await this.flagService.addComment(this.editingFlag.id, { text });
      this.editingFlag.comments = saved.comments;
      this.editingFlag.flag.comments = saved.comments;
      this.toastr.success('Comment added!');
    }
  }

  async removeComment(index) {
    this.dialog.confirm().show({
      message: `Do you really want to remove the Comment?`,
      confirmed: async () => {
        const saved = await this.flagService.removeComment(this.editingFlag.id, index);
        this.editingFlag.comments = saved.comments;
        this.editingFlag.flag.comments = saved.comments;
        this.toastr.success('Comment removed!');
      },
    });
  }

  applyTemplate() {
    this.flagGroupTemplateModal.show();
  }

  editRequested() {
    this.activeStep = 1;
  }

  toggleComments() {
    this.showComments = !this.showComments;
  }

  ExtensionGrantedDeadlines() {
    this.ExtensionGrantedDeadlinesModal.show({
      inspection: this.inspection,
      confirmed: () => {
        this.editingGroup = null;
        this.editingFlag = null;
        this.refreshAnswers.emit();
      },
    });
  }

  setDeadlines() {
    this.setDeadlinesModal.show({
      inspection: this.inspection,
      confirmed: () => {
        this.toastr.success('Inspection saved!');
        this.editingGroup = null;
        this.editingFlag = null;
        this.refreshAnswers.emit();
      },
    });
  }

  isBeforeLetterSent() {
    if (this.inspection) {
      switch (this.inspection.underwritingStatus) {
        case UnderwritingStatus.PREPARATION_IN_PROGRESS:
        case UnderwritingStatus.PREPARE_FLAGS:
          return true;
      }
    }
    return false;
  }

  async moveGroupUp(index: number) {
    const temp = this.groups[index - 1];
    this.groups[index - 1] = this.groups[index];
    this.groups[index] = temp;
    this.groups[index].order++;
    this.groups[index - 1].order--;
    await this.groupService.updateOrder(
      this.inspection.id,
      this.groups.map(g => g.id),
    );
    this.toastr.success('Groups updated!');
  }

  async moveGroupDown(index: number) {
    const temp = this.groups[index + 1];
    this.groups[index + 1] = this.groups[index];
    this.groups[index] = temp;
    this.groups[index].order--;
    this.groups[index + 1].order++;
    await this.groupService.updateOrder(
      this.inspection.id,
      this.groups.map(g => g.id),
    );
    this.toastr.success('Groups updated!');
  }

  openRecLetterPanel() {
    this.navigation.action.emit(ReviewNavigationAction.CREATE_LETTER);
  }

  scrollToSection(targetSection: any): void {
    if (this.flagListStep3 && this.flagListStep33.nativeElement) {
      const targetElement = this.flagListStep33.nativeElement.querySelector('.' + targetSection);

      // Wait for Angular to render the content
      setTimeout(() => {
        const scrollContainer = this.flagListStep33.nativeElement;
        const targetElement = scrollContainer.querySelector('.' + targetSection);

        if (targetElement) {
          const targetPosition = targetElement.offsetTop; // Get the top position of the target element within the container
          let padding = 100;
          if (targetSection == 'un-resolved') padding = 0;
          scrollContainer.scrollTop = targetPosition - 20 + padding; // Adjust if you need an offset
        } else {
          console.error('Target element not found');
        }
      });
    }
  }

  handleScroll() {
    if (this.activeStep !== 3) {
      return;
    }

    const sticky = document.getElementsByClassName('sticky-header')[0];
    const stickyTop = sticky.getBoundingClientRect().top;

    const titles = document.getElementsByClassName('step3-status') as any;
    const titleTops = [...titles].map(x => x.getBoundingClientRect().top - stickyTop);

    let current = -1;

    titleTops.forEach((t, i) => {
      if (t < 70) {
        current = i;
      }
    });

    switch (current) {
      case -1:
        this.stickySize = this.unResolved.length;
        this.active = this.stickyTitle = 'Unresolved';
        break;
      case 0:
        this.stickySize = this.partialResponse.length;
        this.active = this.stickyTitle = 'Partial Response';
        break;
      case 1:
        this.stickySize = this.resolved.length;
        this.active = this.stickyTitle = 'Resolved';
        break;
    }
  }
  truncateString(inputString: string): string {
    const maxLength = 85;
    if (inputString && inputString.length)
      return inputString.length > maxLength ? inputString.substring(0, maxLength) + '...' : inputString;
  }

  showReportButton() {
    // Has existing letter or all flags are completed
    return (
      (this.existingLetters && this.existingLetters.length) ||
      (this.activeStep == 1 && this.nCompletedFlags() == (this.allFlags && this.allFlags.length))
    );
  }

  //To show more fields in the card
  showMore(itemId: string) {
    if (this.expandedIds.includes(itemId)) {
      this.expandedIds = this.expandedIds.filter(id => id !== itemId);
    } else {
      this.expandedIds.push(itemId);
    }
  }

  //check if that card show more is selected or not
  isExpanded(itemId: string): boolean {
    return this.expandedIds.includes(itemId);
  }

  active = 'To be Resolved';

  getClass(tab: string) {
    return {
      active: tab === this.active,
      'font-weight-bold': tab === this.active,
    };
  }
  async changeFlagStatusBulk(flagStatus: FlagStatus) {
    this.dialog.confirm().show({
      message: `Do you want to change the status of all selected flags?`,
      confirmed: async () => {
        this.loading = true;
        const flagSelectedIds = this.selectedFlags.map(flag => flag.id);
        await this.flagService.changeFlagsStatus({ flagSelectedIds, flagStatus: flagStatus });
        await this.load();
        this.changeStatus = false;
        this.toastr.success('Flags status changed');
        this.loading = false;
      },
    });
  }

  async updateData(check: boolean) {
    if (check) {
      this.loading = true;
      try {
        await this.load();
      } finally {
        this.loading = false;
      }
    }
  }
  async createGroup(template) {
    this.flagGroupTemplateModal.open = false;

    for (const flag of this.selectedFlags) {
      if (this.hasInfoDefined(flag)) {
        const confirmation = await this.confirmOverridingInfo();

        if (!confirmation) {
          this.flagGroupTemplateModal.show();
          this.flagGroupTemplateModal.preview = false;
          this.flagGroupTemplateModal.loading = false;
          this.loading = false;
          return false;
        }
      }

      const helpPicturesOrNotes = this.selectedFlags.some(
        flag =>
          (flag.helpPictures && flag.helpPictures.length > 0) ||
          (flag.violation?.internalNotes && flag.violation.internalNotes.trim() !== ''),
      );

      if (!this.hasInfoDefined(flag) && helpPicturesOrNotes) {
        const confirmation = await this.confirmOverridingInfo();

        if (!confirmation) {
          this.flagGroupTemplateModal.show();
          this.flagGroupTemplateModal.preview = false;
          this.flagGroupTemplateModal.loading = false;
          this.loading = false;
          return false;
        }
      }

      try {
        this.loading = true;
        const newGroup = await this.flagGroupService.createWithFlags(
          template,
          this.inspection.id,
          this.selectedFlags.map(flag => flag.id),
        );

        this.toastr.success('Group Created');
        this.flagGroupTemplateModal.loading = false;
        this.loading = false;
        await this.load();
        this.flagGroupTemplateModal.cancel();
        return newGroup;
      } catch (error) {
        this.toastr.error('Failed to create group');
        console.error(error);
        return false;
      }
    }
  }

  async editGroupByTemplate(group) {
    group.name = this.flagGroupService.getGroupName(this.groups, group.name);
    await this.flagGroupService.edit(group.id, group);
    await this.load();
  }

  hasNonDiscrepancyFlag() {
    for (const flag of this.selectedFlags) {
      if (flag.subtypeId === 2 || flag.status === 3) {
        return true;
      }
    }
  }
}

enum OverrideOption {
  USE_FLAG_INFO,
  ADD_EMPTY,
  CANCEL,
}

enum UnlinkAllOption {
  KEEP,
  CLEAR,
  CANCEL,
}

enum LastFlagOption {
  KEEP,
  CLEAR,
}
